import aviatrixService from "../services/aviatrix.service";

const handlers = {
    aviatrix: {
        session: {
            set: "aviatrix_session_set"
        }
    }
}

const initVuexState = function(state) {
    state.aviatrix = {
        session: null
    };
}

const initGetters = function(getters) {
    getters.aviatrix = (state => state.aviatrix);
}

const initActions = function(actions) {
    actions[handlers.aviatrix.session.set] = ({ commit }, session) => commit(handlers.aviatrix.session.set, session);
}

const initMutations = function(mutations) {
    mutations[handlers.aviatrix.session.set] = (state, session) => state.aviatrix.session = session;
}

const initAppState = function(appState, store) {
    appState.aviatrix = {
        session: {
            get: () => store.getters.aviatrix.session,
            open: async options => {
                const session = await aviatrixService.openSession(options);
                store.dispatch(handlers.aviatrix.session.set, session);
            },
            openDemo: async options => {
                const session = await aviatrixService.openDemoSession(options);
                store.dispatch(handlers.aviatrix.session.set, session);
            },
            close: async () => {
                store.getters.aviatrix.session && await aviatrixService.closeSession();
                store.dispatch(handlers.aviatrix.session.set, null);
            }
        }
    }
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/aviatrix.js